// extracted by mini-css-extract-plugin
export default {"playerwrapper":"movie_playerwrapper__GAvnn","reactplayer":"movie_reactplayer__qU+Rp"};